import { jsx as _jsx } from "react/jsx-runtime";
import { SwapButton } from '../../components/SwapButton';
import { useGasSufficiency } from '../../hooks';
export const StartSwapButton = ({ onClick, currentRoute, text, }) => {
    const { insufficientFunds, insufficientGas, isLoading: isGasSufficiencyLoading, } = useGasSufficiency(currentRoute);
    return (_jsx(SwapButton, { onClick: onClick, text: text, currentRoute: currentRoute, disabled: insufficientFunds || !!insufficientGas?.length, loading: isGasSufficiencyLoading }));
};
